<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-data-table :search="search" :headers="headers" :items="qrcodes" sort-by="nome" class="elevation-1" style="border-radius: 10px;">
      <template v-slot:top>
        <v-toolbar flat color="white" style="border-radius: 10px;">
          <v-toolbar-title class="textoUser">QR CODES</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
          <v-spacer></v-spacer>
          <v-btn text color="#4A148C" @click="cadastrarQRCode" tile>
            <v-icon left>add_circle</v-icon>Adicionar QR Code
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <!-- <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="editItem(item)">edit</v-icon>
          </template>
          <span>Editar</span>
        </v-tooltip> -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="deleteItem(item)">delete</v-icon>
          </template>
          <span>Excluir</span>
        </v-tooltip>
      </template>
      <template slot="no-data">
        <v-row>
          <v-col>
            <v-alert dark dense text outlined :value="true" color="warning" icon="info">Nenhum QR Code cadastrado</v-alert>
          </v-col>
        </v-row>
      </template>
      <template slot="no-results">
        <v-row>
          <v-col>
            <v-alert dark dense text outlined :value="true" color="warning" icon="info">Sua pesquisa por "{{search}}" não trouxe resultados</v-alert>
          </v-col>
        </v-row>
      </template>
    </v-data-table>

    <!-- DIÁLOGO PARA CADASTRAR QR CODE -->
    <v-dialog v-model="cadastroQRCode" persistent max-width="350px">
      <v-card style="border-radius: 10px;">
        <v-card-title style="justify-content: center; padding: 8px;">
          <span class="texto" style="margin-bottom: -23px">CADASTRAR QR CODE</span>
        </v-card-title>
        <v-card-text style="text-align: center; padding: 0px 5px 0px">
          <v-container>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="6" md="12">
                <v-radio-group v-model="tipo" row hide-details>
                  <v-radio color="#7B1FA2" label="QRCODE" value="1"></v-radio>
                  <v-radio color="#7B1FA2" label="CÓDIGO" value="2"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" sm="6" md="12" v-if="tipo=='1'">
                <qrcode-stream @decode="onDecode"></qrcode-stream>
              </v-col>
              <v-col cols="12" sm="6" md="12" v-if="tipo=='2'">
                <v-text-field light label="CÓDIGO" color="#7B1FA2" type="tel" outlined hide-details dense v-model="codigoQrCode"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions style="margin-top: -32px;padding: 20px 5px 0px;">
          <v-container fluid grid-list-md>
            <v-layout row wrap justify-center>
              <v-flex xs6 sm6 lg6 v-if="tipo == 2">
                <v-btn dark depressed block color="#7B1FA2" style="border-radius: 7px;" large @click="verificaQrCode">Cadastrar</v-btn>
              </v-flex>
              <v-flex xs6 sm6 lg6>
                <v-btn dark depressed block color="#D32F2F" style="border-radius: 7px;" large @click="close">Fechar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- FIM DO DIÁLOGO PARA CADASTRAR QR CODE -->
    <loading :active.sync="isLoading" :can-cancel="true" color="#7B1FA2" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import moment from 'moment'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading, },
    data: () => ({
      search: '',
      eventoId: '',
      eventoIdAtual: '',
      fullPage: true,
      isLoading: false,
      loading: false,
      cadastroQRCode: false,
      audio: '',
      tipo: '1',
      codigoQrCode: '',
      confirmacaoCheckin: false,
      senhaInformada: '',
      exibeSenha: false,
      idQrCode: '',
      idAssociacao: '',
      nomeVigilante: '',
      qualificacaoVigilante: '',
      fotoVigilante: '',
      senhaQrCode: '',
      qrcodes: [],
      headers: [
        { text: 'Código', align: 'start', value: 'qrcode' },
        { text: 'Situação', value: 'situacao' },
        { text: 'Ações', value: 'action', align: 'center', sortable: true }
      ],
      rules: {
        max: v => v.length <= 4 || 'Máximo de 4 dígitos',
        min: v => v.length >= 4 || 'Mínimo de 4 dígitos'
      },
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
    }),

    mounted() {
      this.carregaQRCodes()
      this.audio = new Audio(require("../assets/beep.mp3"))
    },

    methods: {
      async carregaQRCodes() {
        this.qrcodes = []
        this.isLoading = true
        await axios.get(`${baseApiUrl}QRCodes`).then(response => {
          if (response.data) {
            for (var key in response.data) {
              if (response.data.hasOwnProperty(key)) {
                this.qrcodes.push(response.data[key])
              }
            }
            this.isLoading = false
          }
        })
      },

      cadastrarQRCode() {
        this.tipo = '1'
        this.audio.play()
        this.cadastroQRCode = true
      },

      onDecode(decodedString) {
        this.codigoQrCode = decodedString
        this.audio.play()
        this.verificaQrCode()
      },

      async verificaQrCode() {
        var vm = this;
        if (this.codigoQrCode != '') {
          this.isLoading = true
          try {
            await axios.post(`${baseApiUrl}QRCodes`, {"qrcode":this.codigoQrCode, "situacao":"LIVRE"}).then(response => {
              if (response.data) {
                this.tipo = '0'
                this.codigoQrCode = ''
                this.cadastroQRCode = false
                this.carregaQRCodes()
                this.isLoading = false
                vm.$refs.chamaSnackbar.snack("#0288D1", "QR Code cadastrado com sucesso!", "INFORMAÇÃO")
              }
            })
          } catch (error) {
            this.tipo = '0'
            this.codigoQrCode = ''
            this.cadastroQRCode = false
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao cadastrar QR Code", "DESCULPE")
          }
        }
      },

      compare(a) {
        // Use toUpperCase() to ignore character casing
        const dataA = moment(this.formatDateHora(a.fim), 'DD/MM/YYYY HH:mm:ss', true).format()
        //const dataB = new Date(moment(this.formatDatePadrao(b.fim)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z'))
        const dataC = moment().format()

        let comparison = 0;
        if (dataC >= dataA)
          comparison = 1;
        /* else
          if (dataA >= dataC && dataB < dataA)
            comparison = -1; */
        else
        if (dataC < dataA)
          comparison = -1;
        return comparison;
      },

      formatDateHora(date) {
        if (!date) return null

        const [year, month, day] = date.substr(0, 10).split('-')
        return `${day}/${month}/${year}` + " " + date.substr(11, 8)
      },

      async deleteItem(item) {
        var vm = this
        var r = confirm('Deseja realmente excluir o QR Code de código ' + item.qrcode + '?')
        if (r == true) {
          if (item.situacao == 'OCUPADO') {
            vm.$refs.chamaSnackbar.snack("#EF5350", "Não é possível excluir QR Code com situação ocupada!", "DESCULPE")
          } else {
            this.isLoading = true
            await axios.delete(`${baseApiUrl}QRCodes/${item.id}`)
            .then(() => {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
              this.carregaQRCodes()
            }).catch(() => {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO")
            })
          }
        }
      },

      close() {
        this.tipo = '0'
        this.codigoQrCode = ''
        this.cadastroQRCode = false
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px;
    width: 120px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
</style>